import { useMemo } from 'react';
import Dictionary from "../utils/dictionary";
export function useDictionary(_ref) {
  var translations = _ref.translations,
      locale = _ref.locale;
  return useMemo(function () {
    return new Dictionary(translations, locale);
  }, [locale, translations]);
}